// Tracking de Clarity para el embudo de /pages/mi-agua.
// Envuelve las funciones ya expuestas por miagua.js. Si Clarity no esta
// presente no hace nada: todas las llamadas van detras de un guard.
(function() {

  function ev(nombre) {
    if (window.clarity) { try { window.clarity('event', nombre); } catch (e) {} }
  }
  function tag(clave, valor) {
    if (window.clarity && valor) { try { window.clarity('set', clave, String(valor)); } catch (e) {} }
  }
  function upgrade(motivo) {
    if (window.clarity) { try { window.clarity('upgrade', motivo); } catch (e) {} }
  }

  function $(id) { return document.getElementById(id); }

  // --- Paso 1: ver el resultado -------------------------------------------
  var _submit = window.maSubmit;
  if (typeof _submit === 'function') {
    window.maSubmit = function() {
      var antes = $('ma-comuna') ? $('ma-comuna').value : '';

      _submit.apply(this, arguments);

      var exito = $('miaguaSuccessView') &&
                  $('miaguaSuccessView').classList.contains('visible');

      if (!exito) {
        // Sigue habiendo gente que no logra pasar. Esto es lo que hay que ver bajar.
        ev('miagua_comuna_rechazada');
        tag('comuna_rechazada', antes.slice(0, 40));
        upgrade('comuna rechazada');
        return;
      }

      var despues = $('ma-comuna').value;

      // Si el texto cambio, la normalizacion hizo el trabajo: la persona
      // escribio la comuna y nunca toco el dropdown. Antes esto era un rechazo.
      if (despues !== antes) {
        ev('miagua_comuna_texto_libre');
        tag('comuna_corregida_desde', antes.slice(0, 40));
      }

      ev('miagua_resultado_visto');
      tag('comuna', despues);
      tag('nivel_dureza', $('maResNivel') ? $('maResNivel').textContent : '');
      upgrade('diagnostico de agua completado');
    };
  }

  // --- Paso 2: el informe por email ---------------------------------------
  var _informe = window.maEnviarInforme;
  if (typeof _informe === 'function') {
    window.maEnviarInforme = function() {
      var visibleAntes = $('maInformeWrap') &&
                         $('maInformeWrap').style.display !== 'none';

      _informe.apply(this, arguments);

      var oculto = $('maInformeWrap') &&
                   $('maInformeWrap').style.display === 'none';

      if (visibleAntes && oculto) {
        ev('miagua_informe_enviado');
        upgrade('email capturado');
      } else {
        ev('miagua_informe_email_invalido');
      }
    };
  }

  // --- Cual de los dos CTA se lleva el clic -------------------------------
  document.addEventListener('DOMContentLoaded', function() {
    var tarjeta = $('maResultadoLink');
    if (tarjeta) {
      tarjeta.addEventListener('click', function() {
        ev('miagua_cta_tarjeta');
        upgrade('clic al producto desde mi-agua');
      });
    }
    var puente = document.querySelector('.miagua-puente-cta');
    if (puente) {
      puente.addEventListener('click', function() {
        ev('miagua_cta_puente');
        upgrade('clic al producto desde mi-agua');
      });
    }
  });

})();
